import { createFileRoute } from "@tanstack/react-router";
import { ServicesScreen } from "../components/settings/services-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/tjanster")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <ServicesScreen franchiseId={franchise.id} />;
}
